import { get } from "lodash-es";

import { GridColDef } from "@mui/x-data-grid-pro";

import { useSelector } from "../store";

function useClusterColumn() {
  const { byId } = useSelector((state) => state.namespaces);

  const clusterColumn: GridColDef = {
    display: "flex",
    headerName: "Cluster",
    field: "cluster",
    flex: 1,
    valueGetter: (_value, row) => {
      return get(byId, row.namespaceId + ".namespace.name", "");
    },
    sortComparator: (_v1, _v2, p1, p2) => {
      const namespaceName = p1.value.toString().toLowerCase();
      const namespaceName2 = p2.value.toString().toLowerCase();
      return namespaceName > namespaceName2 ? -1 : 1;
    },
  };
  return clusterColumn;
}
export default useClusterColumn;
